module.exports = __webpack_public_path__ + "img/trammit.44954a6f.svg";